import { Interlocuteur } from '@/models/Interlocuteur';
import { Site } from '@/models/Site';
import { RootState } from '@/plugins/store';
import { Component } from 'vue';
import { GetterTree } from 'vuex';
import { ContactState } from './state';

export const getters: GetterTree<ContactState, RootState> = {

    isContactFormValid(state): boolean {
        switch (state.step) {
            case 0:
                return state.site !== undefined;
            case 1:
                return state.interlocuteur != undefined;
            case 2:
                return state.objet.length !== 0 && state.description.length !== 0;
            default:
                return false;
        }
    },

    getSite(state): Site {
        if(state.site){
            return state.site;
        }
        throw new Error('Site vide');
    },

    getInterlocuteur(state): Interlocuteur {
        if(state.interlocuteur){
            return state.interlocuteur;
        }
        throw new Error('Interlocuteur vide');
    },

    getCurrentStep(state): Component {
        return state.steps[state.step];
    },

    isLastStep(state): boolean {
        return state.step === state.steps.length-1;
    },

    isExportLoading(state) :boolean {
        return state.exportLoading;
    }

};
